import coordId from './coordId';
import { dragRectToBounds } from './pointer';
import { renderPixels } from './renderCore';

const WIDTH = 1200;
const HEIGHT = 900;

// The single render seam. `generate()` resolves whatever the caller sent (a drag
// rectangle or manual axis values) down to one region's bounds, then everything
// funnels through here.
//
// The maths moved out to renderCore.js, which has no DOM in it and therefore runs
// in Node and in a Worker as well as here. What is left is the browser tail: put
// the pixels on a canvas and read a data URL back off it. That is the whole of
// what ties rendering to a browser, and the reason the split was worth doing —
// the print render (D4) and the og:image unfurl render (P1) need these exact
// numerics without any of these four lines.
const renderRegion = (realMin, realMax, imaginaryMin, imaginaryMax, width, height) => {

    const pixels = renderPixels(realMin, realMax, imaginaryMin, imaginaryMax, width, height);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");

    // renderPixels already returns exactly the RGBA layout ImageData wants, so
    // this wraps the buffer rather than copying it.
    ctx.putImageData(new ImageData(pixels, width, height), 0, 0);

    const zoom = {
        realMin: realMin,
        realMax: realMax,
        imaginaryMin: imaginaryMin,
        imaginaryMax: imaginaryMax,
        dataUrl: canvas.toDataURL()
    };
    zoom.id = coordId(zoom);

    canvas.remove();

    return zoom;
};

const generate = (

    zoomParams

) =>  {

    const width = zoomParams.width || WIDTH;
    const height = zoomParams.height || HEIGHT;

    if (zoomParams.manual) {

        let newMinR = zoomParams.axisValues.newMinR;
        let newMaxR = zoomParams.axisValues.newMaxR;
        let newMinI = zoomParams.axisValues.newMinI;
        let newMaxI = zoomParams.axisValues.newMaxI;

        return renderRegion(newMinR, newMaxR, newMinI, newMaxI, width, height);

    } else {

        // Pointer coords arrive already normalized to canvas pixels (see
        // Display.js); dragRectToBounds turns the drag rectangle into the new
        // complex-plane bounds.
        const dragRect = {
            x0: zoomParams.mousePositions.tlx,
            y0: zoomParams.mousePositions.tly,
            x1: zoomParams.mousePositions.brx,
            y1: zoomParams.mousePositions.bry
        };
        const currentBounds = {
            realMin: zoomParams.axisParams.realMin,
            realMax: zoomParams.axisParams.realmax,
            imaginaryMin: zoomParams.axisParams.imaginaryMin,
            imaginaryMax: zoomParams.axisParams.imaginaryMax
        };

        const b = dragRectToBounds(dragRect, currentBounds, width, height);

        return renderRegion(b.realMin, b.realMax, b.imaginaryMin, b.imaginaryMax, width, height);
    }
};

export default generate;
